// @flow
import React from 'react';
import { withRouter } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import Box from 'bizom-mui/lib/Box';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';

type Props = {
  classes: any,
  history: any,
};

const styles = ({ palette }) => ({
  navButtons: {
    position: 'fixed',
    right: 0,
    bottom: 0,
    backgroundColor: palette.background.paper,
  },
  button: {
    borderRadius: 0,
  },
});

const TermsAndConditions = ({ classes, history }: Props) => {
  const url = `${process.env.REACT_APP_RETAILER_APP_TNC_URL || ''}`;
  if (!url) return null;

  return (
    <React.Fragment>
      <Box mb={6}>
        <iframe
          title="tnc"
          src={url}
          style={{ border: 'none', height: '100vh', width: '100%' }}
        />
      </Box>
      <Grid container className={classes.navButtons}>
        <Grid item xs={12}>
          <Button
            className={classes.button}
            fullWidth
            size="large"
            color="primary"
            variant="contained"
            onClick={() => history.goBack()}
          >
            Close
          </Button>
        </Grid>
      </Grid>
    </React.Fragment>
  );
};

export default withRouter(withStyles(styles)(TermsAndConditions));
